import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Table, Breadcrumb, Badge, Select, Input, Pagination } from 'antd';
import moment from 'moment';
import { Log } from '../../models';
import styles from './index.less';
import PageHeaderLayout from '../../layouts/PageHeaderLayout';
import statusEnum from '../Orders/statusEnum.json';

export class LogComponent extends Component {
  static propTypes = {
    getAllLogs: PropTypes.func.isRequired,
    log: PropTypes.object,
    users: PropTypes.array,
  }

  static defaultProps = {
    users: [],
    log: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      current: 1,
      limit: 15,
      user_id: '',
      order: '',
    };
  }

  componentDidMount() {
    this.props.getAllLogs({
      limit: this.state.limit,
      offset: this.state.current - 1,
    });
  }

  onChange = async (pagination, userId, orderId) => {
    console.log(orderId);

    const nextState = {
      current: pagination.current,
    };

    if (userId !== undefined) {
      nextState.user_id = userId;
    }

    if (orderId !== undefined) {
      nextState.order = orderId;
    }

    this.setState(nextState);

    await this.props.getAllLogs({
      limit: this.state.limit,
      offset: pagination.current - 1,
      ...nextState,
    });
  }

  breadcrumb = (
    <Col span={24}>
      <div className={styles.pageTop}>
        <Col span={4}>
          <Breadcrumb className={styles.Topbread}>
            <Breadcrumb.Item>
              <Link to="/" style={{ fontSize: 13 }}>Нүүр</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 13 }}>Захиалгын лог</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </div>
    </Col>
  )

  columns = [{
    title: 'ID',
    key: 'order_id',
    width: '100px',
    render: (text, record) => (
      <Link to={`orders/detail/${record.order_id}`} className={styles.orderTitle}>{record.order_id}</Link>
    ),
  }, {
    title: 'Хэрэглэгч',
    key: 'localUser.name',
    width: '140px',
    dataIndex: 'localUser.name',
  }, {
    title: 'Өөрчилсөн төлөв',
    key: 'status',
    width: '180px',
    render: (text, record) => (
      <div>
        <Badge status={statusEnum[record.state].status} text={statusEnum[record.state].text} />
      </div>
    ),
  }, {
    title: 'Огноо',
    key: 'date',
    width: '150px',
    render: (text, record) => <div>{moment(`${record.created_at}`).format('YYYY.MM.DD')} {moment(`${record.created_at}`).format('HH:mm')}</div>,
  }, {
    title: 'Тэмдэглэл',
    key: 'note',
    dataIndex: 'note',
  }]

  render() {
    return (
      <PageHeaderLayout
        content={this.breadcrumb}
      >
        <Card bordered>
          <div className={styles.tableList}>
            <Row type="flex" justify="end" style={{ marginBottom: 30 }} gutter={30}>
              <Col span={10}>
                <span className={styles.pageHeading}>Захиалгын лог</span>
              </Col>
              <Col span={14}>
                <Col span={12}>
                  <div>
                    <Select
                      showSearch
                      size="small"
                      style={{ width: '100%' }}
                      placeholder="Админаар хайх"
                      value={this.state.user_id}
                      onChange={value => this.onChange({ current: 1 }, value)}
                    >
                      <Select.Option value="">--Бүгд--</Select.Option>
                      {this.props.users.map(user => (
                        <Select.Option value={user.id} key={user.id}>{user.name}</Select.Option>
                      ))}
                    </Select>
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ paddingLeft: 10 }}>
                    <Input.Search
                      placeholder="Захиалгын дугаараар хайх"
                      size="small"
                      value={this.state.order}
                      onChange={event => this.onChange({ current: 1 }, undefined, event.target.value)}
                    />
                  </div>
                </Col>
              </Col>
            </Row>
          </div>

          <Table
            rowKey={record => record.id}
            columns={this.columns}
            className={styles.dataTable}
            dataSource={this.props.log.data}
            // onChange={pagination => this.onChange(pagination)}
            pagination={false}
            // pagination={{ total: this.props.log.total, pageSize: this.state.limit, current: this.state.current }}
            loading={this.props.log.isLoading}
          />
          <div style={{ marginTop: 20, float: 'right' }}>
            <Pagination
              defaultCurrent={1}
              onChange={page => this.onChange({ current: page })}
              pageSize={this.state.limit}
              total={this.props.log.total}
              current={this.state.current}
              size="small"
            />
          </div>
        </Card>
      </PageHeaderLayout>
    );
  }
}

const mapStateToProps = state => ({
  log: state.log.all,
  users: state.user.data.list,
});

const mapDispatchToProps = {
  getAllLogs: Log.getAllLogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(LogComponent);



// WEBPACK FOOTER //
// ./src/containers/Log/index.js